import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowforwardFillNomargin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "11",
    height: "20",
    fill: "none",
    viewBox: "0 0 11 20",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.637 16.813a1.15 1.15 0 0 1 0-1.626L6.824 10 1.637 4.813a1.15 1.15 0 0 1 1.626-1.626l6 6c.45.449.45 1.177 0 1.626l-6 6a1.15 1.15 0 0 1-1.626 0",
    clipRule: "evenodd"
  }));
}
var IcArrowforwardFillNomargin = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowforwardFillNomargin));

export { IcArrowforwardFillNomargin as I };
